export default __webpack_public_path__ + "static/assets/82453051b1de402f0a020081f0ef0492.svg";